export default {
  init() {
    window.onscroll = () => { this.scrollFunction(); };
    this.button = document.querySelector('.scroll-to-top');
    this.mouseOverOutOnButton();
    this.eventListener();
  },

  mouseOverOutOnButton() {
    this.button.addEventListener('mouseover', () => {
      this.stopTimer();
    });
    this.button.addEventListener('mouseout', () => {
      this.startTimer();
    });
  },

  startTimer() {
    this.timeout = setTimeout(() => {
      this.button.style.display = 'none';
    }, 3000);
  },

  stopTimer() {
    clearTimeout(this.timeout);
  },

  topFunction() {
    $('html, body').animate({ scrollTop: 0 }, 500);
    return false;
  },

  eventListener() {
    this.button.addEventListener('click', () => {
      this.topFunction();
    });
  },

  scrollFunction() {
    const bodyScrollTop = document.body.scrollTop;
    const documentScrollTop = document.documentElement.scrollTop;
    const navHeight = 76;
    this.stopTimer();
    if (bodyScrollTop > navHeight || documentScrollTop > navHeight) {
      this.button.style.display = 'block';
      this.startTimer();
    } else {
      this.button.style.display = 'none';
    }
  },
};
